module.exports = __webpack_public_path__ + "static/media/logo.ccc75bbb.png";